import { QuartileBar } from "components/QuartileBar";
import useLabels from "hooks/useLabels";

export const QuartileLoading = () => {
  const [quartileTitle] = useLabels("quartile.title");

  return (
    <div className="flex flex-col items-start gap-y-3 w-[264px]">
      <div className="h-3 w-[151px] bg-bg-subtle rounded-full"></div>
      <div className="flex items-center sm:justify-start sm:gap-x-4 w-full tiny-md text-fg-base gap-x-2">
        <div className="flex flex-wrap sm-normal text-fg-muted shrink-0">
          <span>{quartileTitle}</span>
        </div>
        <QuartileBar quartile={null} />
      </div>
    </div>
  );
};
